import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "stats"
}
const _hoisted_2 = { colspan: "3" }
const _hoisted_3 = { class: "open-close" }
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = { class: "left" }
const _hoisted_8 = {
  colspan: "2",
  class: "right"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "two-table"
}
const _hoisted_11 = { class: "stats" }
const _hoisted_12 = { colspan: "2" }
const _hoisted_13 = { class: "open-close" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "stat-value" }
const _hoisted_16 = { class: "stats" }
const _hoisted_17 = { colspan: "2" }
const _hoisted_18 = { class: "open-close" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = { class: "stat-value" }
const _hoisted_21 = { class: "left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("fieldset", null, [
    (_ctx.editable)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (category) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: category }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_2, [
                    _createElementVNode("label", _hoisted_3, [
                      _withDirectives(_createElementVNode("input", {
                        class: "hidden",
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.categoryOpenClose[category]) = $event)
                      }, null, 8, _hoisted_4), [
                        [_vModelCheckbox, _ctx.categoryOpenClose[category]]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.displayName(category)), 1)
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleStatList(category), (stat) => {
                  return (_openBlock(), _createElementBlock("tr", { key: stat }, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.displayStatAbbrev(stat)), 1),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.statAdjustments[stat]) = $event),
                        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.adjustmentsOnChange && _ctx.adjustmentsOnChange(...args)))
                      }, null, 40, _hoisted_5), [
                        [_vModelText, _ctx.statAdjustments[stat]]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.displayStatValue(stat, _ctx.statsObj[stat])), 1)
                  ]))
                }), 128))
              ], 64))
            }), 128)),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_7, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editable) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.editable]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.displayName("補正値入力モード")), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.initializable) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.initializable]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.displayName("補正値0初期化")), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  disabled: !_ctx.initializable,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.initializeAdjustments && _ctx.initializeAdjustments(...args)))
                }, _toDisplayString(_ctx.displayName("実行")), 9, _hoisted_9)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.editable)
      ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("table", _hoisted_11, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category1List, (category) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: category }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_12, [
                            _createElementVNode("label", _hoisted_13, [
                              _withDirectives(_createElementVNode("input", {
                                class: "hidden",
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.categoryOpenClose[category]) = $event)
                              }, null, 8, _hoisted_14), [
                                [_vModelCheckbox, _ctx.categoryOpenClose[category]]
                              ]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.displayName(category)), 1)
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleStatList(category), (stat) => {
                          return (_openBlock(), _createElementBlock("tr", { key: stat }, [
                            _createElementVNode("th", null, _toDisplayString(_ctx.displayStatAbbrev(stat)), 1),
                            _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.displayStatValue(stat, _ctx.statsObj[stat])), 1)
                          ]))
                        }), 128))
                      ], 64))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("table", _hoisted_16, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category2List, (category) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: category }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_17, [
                            _createElementVNode("label", _hoisted_18, [
                              _withDirectives(_createElementVNode("input", {
                                class: "hidden",
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.categoryOpenClose[category]) = $event)
                              }, null, 8, _hoisted_19), [
                                [_vModelCheckbox, _ctx.categoryOpenClose[category]]
                              ]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.displayName(category)), 1)
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleStatList(category), (stat) => {
                          return (_openBlock(), _createElementBlock("tr", { key: stat }, [
                            _createElementVNode("th", null, _toDisplayString(_ctx.displayStatAbbrev(stat)), 1),
                            _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.displayStatValue(stat, _ctx.statsObj[stat])), 1)
                          ]))
                        }), 128))
                      ], 64))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_21, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editable) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.editable]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.displayName("補正値入力モード")), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}